import { Component } from '@angular/core';

@Component({
  selector: 'ppl-inner-page-layout',
  standalone: true,
  imports: [],
  templateUrl: './inner-page-layout.component.html',
  styleUrl: './inner-page-layout.component.css'
})
export class InnerPageLayoutComponent {

}
